import type { FC } from 'react';
import { Center, CenterProps } from '@chakra-ui/react';

export type QCenterProps = CenterProps;

export const QCenter: FC<QCenterProps> = (props) => {
  return <Center {...props} />;
};
